const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddUsersTransparentSmall(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "#0F6FBA",
    d: "M587 966h-2l-26 2-8 2h-16l-62 4-48 1h-46l-4 1a239 239 0 0 1-18-1l-4-2-17-1-66-6-61-10h-7l-11-2-2-2-65-18-9-1-1-1-3-1v-1l-12-6-8-3-2-1-5-3-4-2v-1l-4-3-3-1v-1l-3-2-2-2-1-1-1-1-1-1-1-1a5 5 0 0 0-2-2 10 10 0 0 0-2-2v-2l-3-3h1l-1-4a60 60 0 0 1-6-48l18-55 3-10 1-2 10-18 4-10 4-6v-1l3-4 1-3h1l1-2s0 1 0 0l3-5 1-1 2-3h1l1-2h1v-1h1l1-2a18 18 0 0 0 2-4h1l1-2 1-1 4-4 1-1h1v-1l1-1 1-2h1v-1h1v-1h1l1-2h1l2-2 1-1 1-1a17 17 0 0 1 3-3l5-3 1-1a45 45 0 0 0 4-4l1-1 2-1 1-1h1l1-1 2-2h1l1-1h1a8 8 0 0 0 2-2 13 13 0 0 0 3-2l50-29 79-35 7-3 10 14a178 178 0 0 0 129 65 158 158 0 0 0 70-11 204 204 0 0 0 63-39l8-6 17-13a6 6 0 0 0 2 0l35 18a212 212 0 0 0-66 192 203 203 0 0 0 47 103l29 28-40 11a25 25 0 0 1-6 1l-6 1Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#47B854",
    d: "m639 953-29-28a203 203 0 0 1-47-103 210 210 0 0 1 66-192c18-16 37-29 58-38a149 149 0 0 0 21-6l12-4 25-3a205 205 0 0 1 50 0h14a292 292 0 0 1 36 10v1l3 1h2a198 198 0 0 1 65 40v1l2 1a177 177 0 0 1 36 45v1l1 1v1l3 5 2 2h-1l2 2 1 2v1l1 1v1a17 17 0 0 0 1 2v1l9 24 3 7h-1l5 17v1a64 64 0 0 0 1 6l2 17v2l1 3c3 64-17 119-63 165a204 204 0 0 1-80 48l-16 4h-4l-29 4h-20a131 131 0 0 1-46-5l-4 1a208 208 0 0 1-82-39m111-55v1l2 1 1 2 1 1h1l1 1h1l3 2 2 1v1c6 3 15 3 19-1h1l1-1h1l2-2 10-11 1-3 1-1v-5l1-69h65c4 0 7-1 11-3 10-2 14-9 18-19 4-7 2-17-3-21l-1-2a7 7 0 0 1-1-1l-2-2-2-1-2-2-2-1v-1a12 12 0 0 0-3 0v-1l-7-1h-65l-7-1v-68l-2-6c-4-10-11-17-22-18-17-1-27 9-29 28v65h-72l-6 2c-3 2-7 3-10 6-13 12-10 31 7 43l2 1 12 3h67v57l1 2-1 3c-3 6-1 11 2 16v1l1 1v1l1 1v1h1Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#187DD0",
    d: "M673 356a110 110 0 0 1-24 51 40 40 0 0 1-31 15c-12 49-34 92-75 124a164 164 0 0 1-54 31c-16 5-32 4-48 4a120 120 0 0 1-65-17l-9-4-1-1a5676 5676 0 0 1-30-25l-7 27-4 5 9-32a9 9 0 0 0-2-7 207 207 0 0 1-54-100c-1-3-2-5-5-5a45 45 0 0 1-29-20 124 124 0 0 1-21-88c1-8 5-16 13-20h2c4 1 8 0 11 2a55 55 0 0 1 15 13l14 25 2-6 14-88c1-8 3-17 11-23 14-12 31-21 50-25l17-2 1 2-33 39c8 4 17 6 26 6a416 416 0 0 0 113-10c17-4 32-14 47-23 10-5 19-12 25-21l12-16v17c1 16 3 32 12 46l18 31a98 98 0 0 1 16 45l4 35c4-7 8-16 14-24 8-11 15-23 31-22h1c6 0 10 5 13 11l2 5v2l-1 38v5m-272-64 1 1c4 0 6-2 7-6 0-4-1-7-6-9-20-15-53-6-69 9-3 4-1 7 1 10s5 2 8 0a56 56 0 0 1 52-6l5 1h1m-11 190a72 72 0 0 0 97 20 93 93 0 0 0 32-34l5-14c1-6-4-9-9-7l-11 3a150 150 0 0 1-51 10 161 161 0 0 1-65-12c-3-1-8-1-11 1-4 2-3 7-1 11l14 22m130-161-7 4c-12 9-12 30 0 39 8 6 19 6 26 1a27 27 0 0 0 10-29c-3-10-11-18-29-15m-163 6a24 24 0 0 0-4 28 24 24 0 0 0 23 14c9-1 17-9 20-19a24 24 0 0 0-11-26c-10-7-19-5-28 3m118 78-10-44c-1-2-5-5-7-5-4 0-6 4-5 7l2 16 8 20c5 12 0 19-13 19l-10 1c-3 1-4 4-6 5 2 2 3 5 5 5 6 1 12 2 17 1 8-1 15-4 18-12 2-4 1-8 1-13m88-122a61 61 0 0 0-29-12 48 48 0 0 0-32 6c-4 2-7 8-5 12 3 5 7 3 11 2a56 56 0 0 1 40 0l13 7c4 2 7 2 10-2s1-6-2-9l-6-5Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0661A2",
    d: "M658 295c-16-1-23 11-31 22l-15 24-3-35a98 98 0 0 0-16-45l-18-31c-9-14-11-30-12-46v-17l-12 16a83 83 0 0 1-25 21c-15 9-30 18-47 23a416 416 0 0 1-113 10 56 56 0 0 1-26-6l33-39-1-2-17 2c-19 4-35 13-50 25-8 6-10 15-11 23l-14 88-2 6-14-25a55 55 0 0 0-15-13c-3-2-7-1-11-3l-4-24a255 255 0 0 1-3-71c1-17 5-34 12-49l1-6h1a27 27 0 0 0 2-5 170 170 0 0 1 70-73 236 236 0 0 1 60-23l3 1 31-7 23-4a308 308 0 0 1 19-3l2 2h37c16 0 31 4 46 9l15 5c25 12 43 30 50 57a69 69 0 0 1 54 21l3 4 7 13c5 11 8 23 8 35a404 404 0 0 1 0 36l-2 24v1l-1 6-1 5-14 45 1 3Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#197FD4",
    d: "m326 566 3-5 7-27 30 25 1 1a85 85 0 0 0 22 25 198 198 0 0 0 49 29 211 211 0 0 0 87 19l41-2a201 201 0 0 1-62 39 158 158 0 0 1-70 12 178 178 0 0 1-92-32c-14-9-27-20-37-34-4-4-6-9-9-14v-1l2-1a104 104 0 0 0 25-30h1v-2h1v-2Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0661A2",
    d: "m567 631-42 2a211 211 0 0 1-87-18 198 198 0 0 1-49-29 86 86 0 0 1-22-26l9 4a120 120 0 0 0 65 17c16 0 32 1 48-4 20-7 37-18 53-31 3 12 7 23 13 33a78 78 0 0 0 29 28 83 83 0 0 1 8 5 368 368 0 0 1-26 19Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#105AB0",
    d: "M375 976c1 0 2-2 4-1h46l48-1 62-4h15l-114 7c-20 1-40 0-61-1Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0E5199",
    d: "m244 143-1 6c-7 15-11 32-12 49a255 255 0 0 0 3 71l3 24-1 1c-3-22-7-43-8-64a174 174 0 0 1 16-87Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#105AB0",
    d: "M202 956h7l61 10 66 6 17 1 4 2-41-2-44-5-70-12ZM72 776l-3 9-18 55a60 60 0 0 0 6 48l1 4a54 54 0 0 1-10-38c2-27 13-53 24-78Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#30AF3F",
    d: "m722 993 3-2a131 131 0 0 0 46 5h20l29-4h3a211 211 0 0 1-102 1Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0E5199",
    d: "m673 235 2-24v-36c0-12-3-24-8-35l-7-13c9 9 12 21 15 33 5 25 4 50-2 75ZM552 44a269 269 0 0 1-14-4 146 146 0 0 0-46-9h-37l-1-2c31-1 61 0 90 11a80 80 0 0 1 8 4Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#30AF3F",
    d: "M808 579h-13c-17-2-33-2-50 0l-25 3 31-5c19-2 38-2 57 2Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#105AB0",
    d: "m116 933 8 1 65 18 2 1-75-20Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0E5199",
    d: "m434 32-23 4-31 7-3-1a1441 1441 0 0 1 57-10Zm224 263-1-3a2458 2458 0 0 1 5-8l-3 10-1 1Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#105AB0",
    d: "m552 970 7-2a456 456 0 0 1 26-2l-33 4Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#30AF3F",
    d: "m975 728-3-6-9-24 12 30Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0F6FBA",
    d: "m673 350 1-37a655 655 0 0 1-1 37Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#105AB0",
    d: "m87 746-4 9a277 277 0 0 1 4-9Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#30AF3F",
    d: "M720 582a240 240 0 0 1-28 10l6-4 22-6Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#105AB0",
    d: "M91 921a58 58 0 0 1 8 3 128 128 0 0 1 12 6c-7-2-13-5-20-9Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#30AF3F",
    d: "M979 745ZM845 589a153 153 0 0 1-16-5 192 192 0 0 1 16 5Zm137 181Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#105AB0",
    d: "m587 966 6-2-6 2ZM117 704l-4 4 4-4Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0E5199",
    d: "m247 138-2 5 1-5Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#30AF3F",
    d: "m957 686-3-5 3 4Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#105AB0",
    d: "M84 918a23 23 0 0 1 5 2l-5-2Zm16-193-3 5 3-5Zm-6 9-3 4 2-4Zm43-49-3 3 3-3ZM76 912l4 2-4-2Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0F6FBA",
    d: "m673 310-2-4a20 20 0 0 1 2 4Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#105AB0",
    d: "m143 681-4 3 4-3ZM80 915l4 2-4-2Zm30-204-2 4 2-4Zm49-42-3 2 3-2Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0F6FBA",
    d: "M673 355v-3 3Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#105AB0",
    d: "m58 893 2 2a9 9 0 0 1-2-2Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0E5199",
    d: "M671 247a13 13 0 0 1 1-5 13 13 0 0 1-1 5Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#105AB0",
    d: "M95 732a4 4 0 0 1-1 2l1-2Zm16 199a7 7 0 0 1 3 1 7 7 0 0 1-3-1Zm-41-23 3 1-3-2Zm86-237a4 4 0 0 1-2 2l1-2Zm-5 3-2 2 2-2ZM73 910l3 1-3-1Zm32-192a6 6 0 0 1-1 2l1-2Zm-2 2-2 3 2-3ZM61 897l2 2-2-2Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#30AF3F",
    d: "M848 590h-3 3Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#105AB0",
    d: "m125 695-1 2 1-2Zm3-2a4 4 0 0 1-2 2l1-2Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#30AF3F",
    d: "m917 633-2-1a6 6 0 0 1 2 1Zm46 64a5 5 0 0 1-1-2l1 2Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#187DD0",
    d: "M324 568v2-2Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#105AB0",
    d: "m63 899 1 1c-1 1-1 0-2-1Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#187DD0",
    d: "M325 566v2-2Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#30AF3F",
    d: "M850 591h-2 2Zm65 40-2-1 1 1Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#105AB0",
    d: "m73 774-1 1 1-2Zm39-65-1 2 1-2Zm-5 6-1 1 1-1Zm-10 15-1 1v-1Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0661A2",
    d: "M594 612h-2 2Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#105AB0",
    d: "M123 697v1-1Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0E5199",
    d: "M553 45h-1 1Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#105AB0",
    d: "M122 698v1-1Zm-1 1-1 1 1-1Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0E5199",
    d: "M656 122Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#105AB0",
    d: "m120 701-1 1 1-1Zm-1 1-1 1 1-1Zm-1 1-1 1 1-1ZM89 921h1-1Zm55-241-1 1 1-1Zm-6 4v1-1Zm-32 33v1-1Zm23-25-1 1 1-1Zm1-1-1 1 1-1ZM67 904l1 1-1-1Zm-2-2 1 1-1-1Zm82-225-1 1 1-1Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFFFE",
    d: "M664 811c-17-12-20-31-7-43 3-3 7-4 11-6l7-1h71v-66c1-19 11-29 29-28 10 1 17 8 21 19l1 75h65l15 1h1l2 1 2 2 2 1 2 2 2 1v1l1 1 1 2a29 29 0 0 1 3 21c-4 9-8 16-19 18l-10 1h-66l-1 77-2 3-10 11-2 2-2 1h-19l-3-1a45 45 0 0 0-2-2h-1v-1h-2l-1-1-1-3-2-1a2 2 0 0 0-1-1l-1-2-1-2-1-16v-60l-2-4h-50l-28-1v-1h-2Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17A324",
    d: "M877 761h-80v-75l1 5v68l6 1h66l7 1Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#30AF3F",
    d: "m666 812 28 1h50v1l-5 1h-61l-12-3Zm132 1h76l-10 2a2878 2878 0 0 1-66-2Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17A324",
    d: "m745 695 1 66h-78l5-1h72v-65Zm53 118v71l-1 6 1-77Zm-53 2v-2l1 4-1 54v1-57Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#30AF3F",
    d: "M893 794c1-7 1-14-3-21 5 3 7 13 3 21ZM762 907h18c-3 4-12 4-18 0Zm-17-30 2 16a13 13 0 0 1-2-16Zm143-108-2-1 2 1Zm2 3-1-1 1 1ZM745 872l1 1-1-1Zm144-102h-1 1ZM756 904Zm-2-1h1c0 1 0 0 0 0Zm-1-1 1 1-1-1Zm-3-3h1-1Zm-1-1h1-1Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0560A1",
    d: "m390 482-14-22c-2-4-3-9 1-11 3-2 8-2 11-1a161 161 0 0 0 65 12c18 0 35-3 51-9l11-4c6-2 10 1 9 7l-5 14a93 93 0 0 1-32 34 70 70 0 0 1-47 10c-21-2-37-14-50-30m27-11-14-3a57 57 0 0 0 53 26c18-1 31-11 41-25-26 7-52 8-80 2Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0661A2",
    d: "M520 321c18-3 26 6 29 15 4 10-1 22-9 29a22 22 0 0 1-27-1c-12-9-12-30 1-39l6-4Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0560A1",
    d: "M357 327c9-8 18-10 28-3a24 24 0 0 1 11 26 24 24 0 0 1-20 19c-10 0-19-5-23-14a24 24 0 0 1 4-28Zm118 78c0 5 1 9-1 13-3 8-10 11-18 12-5 1-11 0-17-1-2 0-3-3-5-4 2-2 3-5 6-6l10-1c13 0 18-7 13-19l-8-20-2-16c-1-3 1-7 5-7 2 0 6 3 7 5l10 44Zm88-122 5 4c4 3 5 6 3 9-3 4-6 4-10 2l-13-7a56 56 0 0 0-40 0c-4 1-8 3-11-2-2-4 1-10 5-12a48 48 0 0 1 32-7 61 61 0 0 1 29 13Zm-163 9-5-1a56 56 0 0 0-52 6c-3 2-6 3-8 0s-4-6-1-10c16-15 49-24 70-8 3 6 1 10-3 13Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0F6FBA",
    d: "M401 292c4-3 6-7 3-13 4 1 5 4 5 8 0 3-3 6-7 6a6 6 0 0 0-1-1Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0560A1",
    d: "M401 292h1-1Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0661A2",
    d: "M367 560v-1 1Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#187DD0",
    d: "M418 471c27 6 53 4 79-2-10 14-23 24-41 25a57 57 0 0 1-53-26l15 3Z",
    style: {
      strokeWidth: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUsersTransparentSmall);
export default __webpack_public_path__ + "static/media/add_users-transparent_small.fd1a55bc367eebacf3ce77683c28c91b.svg";
export { ForwardRef as ReactComponent };